import styled from 'styled-components';
import Header from './Header/Header';
import impulsione from '../Media/logo-impulsionegram.png';
import { useEffect, useState } from 'react';
import * as routes from '../routes';
import NotFound from './NotFound';

const Error = () => {
  const [currentPage, setCurrentPage] = useState('');
  let { pathname } = window.location;

  const t1 = pathname.includes(routes.STORY);
  const t2 = pathname.includes(routes.FEED);
  const t3 = pathname.includes(routes.FOTO);
  const t4 = pathname.includes(routes.REELS);
  const t5 = pathname.includes(routes.VIDEO);
  const t6 = pathname.includes(routes.HOME);
  const t = pathname.includes('/ferramentas/');

  function getCurrentPageURL() {
    let { pathname } = window.location;
    setCurrentPage(pathname);

    if (t) {
      return;
    } else {
      return (window.location.href = 'https://www.impulsionegram.com.br/');
    }

    // if (!currentPage.includes('/ferramentas/')) {
    //   return (window.location.href = 'https://www.impulsionegram.com.br/');
    // }
  }
  useEffect(() => {
    getCurrentPageURL();
  }, []);
  return <>{t && !t1 && !t2 && !t3 && !t4 && !t5 ? <NotFound /> : ''}</>;
};

export default Error;
